module.exports = __webpack_public_path__ + "img/down_angle.a98d227d.jpg";